export class AwsDynamoDBDestination {
    'restoreRegion';
    'encryptionKeyId';
    'restoredName';
    'writeCapacityUnits';
    'restoreBillingMode';
    'tags';
    'advancedIndexConfig';
    'skipActualImport';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreRegion",
            "baseName": "restoreRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoredName",
            "baseName": "restoredName",
            "type": "string",
            "format": ""
        },
        {
            "name": "writeCapacityUnits",
            "baseName": "writeCapacityUnits",
            "type": "number",
            "format": ""
        },
        {
            "name": "restoreBillingMode",
            "baseName": "restoreBillingMode",
            "type": "DynamoDbBillingMode",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "advancedIndexConfig",
            "baseName": "advancedIndexConfig",
            "type": "DynamoDBAdvancedIndexConfig",
            "format": ""
        },
        {
            "name": "skipActualImport",
            "baseName": "skipActualImport",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsDynamoDBDestination.attributeTypeMap;
    }
    constructor() {
    }
}
